import styled from 'styled-components';

import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import Typography from '@material-ui/core/Typography';
import Toolbar from '@material-ui/core/Toolbar';

import { KeyboardDatePicker } from '@material-ui/pickers';

const MaskBackground = '/resources/images/landingPage/mask.png';

export const StyledToolBar = styled(Toolbar)`
    ${() => `
    justify-content: space-between;
    `}
`;

export const StyledPageLayout = styled.div`
    ${({ showBackgroundImage }) => `
    width: 100%;
    background-color: #FFFFFF;
    position: relative;
    white-space: pre-line;
    background-image: ${showBackgroundImage ? `url(${MaskBackground})` : 'none'};
    min-height: 500px;
    background-attachment: fixed;
    background-position: center top;
    background-repeat: no-repeat;
    background-size: cover;

    `}
`;

export const StyledTitleGradient = styled(Typography)`
    ${({ theme }) => `
    font-family: Poppins;
    font-style: normal;
    font-weight: 700;
    text-align: center;

    background: linear-gradient(96.46deg, #07236B 3.72%, #52088B 40.83%, rgba(114, 2, 83, 0.82) 62.89%, #0A093D 100%);
	-webkit-background-clip: text;
	-webkit-text-fill-color: transparent;

    line-height: normal;
    font-size: 32px;

    ${theme.breakpoints.up('sm')} {
        font-size: 40px;
    }
    ${theme.breakpoints.up('md')} {
        font-size: 48px;
    }
    ${theme.breakpoints.up('lg')} {
        font-size: 64px;
    }
    `}
`;

export const StyledButton = styled(Button)`
    ${() => `
    text-decoration: none;
    text-transform: none;
    border-radius: 21px;

    height: 42px;
    
    &.MuiButton-text {
        padding: 6px 10px;
    }
    `}
`;

export const StyledBlurButton = styled(Button)`
    ${() => `
    z-index: 1;
    background-color: rgba(255, 255, 255, 0.2);
    backdrop-filter: blur(70px);
    border-radius: 21px;

    height: 42px;
    min-width: 154px;
    width: max-content;
    padding: 6px 15px;

    `}
`;

export const StyledBlackButton = styled(Button)`
    ${() => `
    z-index: 1;
    background-color: #231A36;

    &:hover {
        background-color: #655e72;
    }

    border-radius: 26px;

    width: max-content;
    height: 45px;
    padding: 6px 35px;

    `}
`;

export const StyledHeaderContainer = styled.div`
    ${({ theme }) => `
    display: flex;
    align-items: center;
    justify-content: space-between;

    padding: 32px 20px;

    ${theme.breakpoints.up('md')} {
        padding: 32px 40px;
    }

    ${theme.breakpoints.up('lg')} {
        padding: 32px 136px;
    }
    `}
`;

export const StyledNavContainer = styled.div`
    ${({ theme }) => `
    z-index: 1;
    display: flex;
    align-items: center;

    ${theme.breakpoints.up('sm')} {
        column-gap: 25px;
    }

    ${theme.breakpoints.up('md')} {
        column-gap: 35px;
    }
    ${theme.breakpoints.up('lg')} {
        column-gap: 45px;  
    }
    `}
`;

export const StyledStartSectionContainer = styled.div`
    ${({ theme }) => `
    z-index: 1;
    width: 100%;
    display: grid;

    row-gap: 20px;
    grid-template-columns: 1fr;

    ${theme.breakpoints.up('sm')} {
        margin-top: 30px;
        row-gap: 0;
        grid-template-columns: 55% 45%;
    }
    `}
`;

export const StyledStartContainer = styled.div`
    ${({ theme }) => `
    z-index: 1;
    display: flex;
    flex-direction: column;
    justify-content: center;

    padding-left: 20px;

    ${theme.breakpoints.up('sm')} {
        padding-top: 13px;
    }

    ${theme.breakpoints.up('md')} {
        padding-top: 5px;
        padding-left: 40px;
    }
    ${theme.breakpoints.up('lg')} {
        padding-top: 90px;
        padding-left: 136px;
    }
    `}
`;

export const StyledStartExampleContainer = styled.div`
    ${({ theme }) => `
    z-index: 1;
    width: 100%;
    display: flex;
    justify-content: flex-end;

    column-gap: 10px;

    ${theme.breakpoints.up('sm')} {
        column-gap: 15px;
    }
    ${theme.breakpoints.up('md')} {
        column-gap: 25px;
    }
    `}
`;

export const StyledStartExampleColumn = styled.div`
    ${() => `
    display: flex;
    flex-direction: column;
    align-items: flex-end;

    `}
`;

export const StyledInfoSectionContainer = styled.div`
    ${({ theme }) => `
    z-index: 1;
    
    display: grid;
    column-gap: 20px;
    row-gap: 20px;

    padding-top: 40px;
    margin-bottom: 40px;
    grid-template-columns: 1fr;


    ${theme.breakpoints.up('sm')} {
        padding-top: 60px;
        margin-bottom: 100px;
        grid-template-columns: 55% 40%;
    }

    ${theme.breakpoints.up('md')} {
        grid-template-columns: 50% 45%;
    }
    ${theme.breakpoints.up('lg')} {
        grid-template-columns: 45% auto;
    }

    `}
`;

export const StyledInfoContainer = styled.div`
    ${({ theme }) => `
    display: flex;
    flex-direction: column;
        
    margin: 0 auto;
    padding-left: 10px;

    ${theme.breakpoints.up('sm')} {
        padding-left: 20px;

    }
    ${theme.breakpoints.up('md')} {
        padding-top: 70px;
        padding-left: 40px;
        
    }
    ${theme.breakpoints.up('lg')} {
        padding-top: 100px;
        padding-left: 136px;
    }
    `}
`;

export const StyledInfoImageContainer = styled.div`
    ${({ theme }) => `
    display: flex;
    flex-direction: column;
    row-gap: 20px;

    align-items: flex-start;

    column-gap: 20px;

    & > img {
        width: 100%;
        max-width: 230px;
    }

    & > div {
        width: 100%;
        display: grid;
        grid-template-columns: auto auto;

        column-gap: 20px;

        padding-left: 15px;

        & > img {
            max-width: 100%;
        }
        
    }

    ${theme.breakpoints.up('sm')} {
        & > img {
            max-width: 300px;
        }

        & > div {
            padding-left: 20px;

            & > img {
        }
        }

    }

    ${theme.breakpoints.up('md')} {
        & > img {
            max-width: 425px;
        }

        & > div {
            padding-left: 50px;
        }

    }
    ${theme.breakpoints.up('lg')} {
      
        & > div {
            display: flex;
        }
    }
    `}
`;

export const StyledFunctionSectionContainer = styled.div`
    ${({ theme }) => `
    margin-top: 30px;
    margin-bottom: 30px;
    width: 100%;

    display: grid;
    
    grid-template-columns: 1fr;

    ${theme.breakpoints.up('sm')} {
        margin-top: 100px;
        margin-bottom: 100px;
        grid-template-columns: 40% 60%;
    }
    `}
`;

export const StyledFunctionImageContainer = styled.div`
    ${({ theme }) => `
    position: relative;

    margin-left: 20px;

    ${theme.breakpoints.up('md')} {
        margin-left: 40px;
    }
    ${theme.breakpoints.up('lg')} {
        margin-left: 136px;  
    }
    `}
`;
export const StyledFunctionContainer = styled.div`
    ${({ theme }) => `
    padding: 0 10px 20px;
    
    ${theme.breakpoints.up('sm')} {
        padding: 0px;
    }
    `}
`;

export const StyleProfile = styled.img`
    ${({ theme }) => `
    width: 100%;
    position: absolute;
    left: 7px;

    max-width: 150px;
    top: 55px;

    ${theme.breakpoints.up('md')} {
        max-width: 200px;
        top: 70px;
    }
    ${theme.breakpoints.up('lg')} {
        max-width: 235px;
        top: 85px;
    }
    `}
`;

export const StyledFunctionInfoTextGroup = styled.div`
    ${({ theme }) => `
    display: flex;
    flex-direction: column;
    row-gap: 10px;

    margin-top: 15px;

    ${theme.breakpoints.up('md')} {
        margin-top: 25px;
        top: 70px;
    }
    ${theme.breakpoints.up('lg')} {
        margin-top: 30px;
    }
    `}
`;

export const StyledFunctionInfoTextContainer = styled.div`
    ${() => `
    display: flex;
    align-items: center;
    column-gap: 15px;
    `}
`;

export const StyledProfressonalSectionContainer = styled.div`
    ${({ theme }) => `
    background-color: #3B3D5B;

    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    padding: 50px 20px;

    ${theme.breakpoints.up('md')} {
        padding: 75px 20px;
    }
    ${theme.breakpoints.up('lg')} {
        padding: 100px 20px;
    }
    `}
`;
export const StyledProfressonalTitleContainer = styled.div`
    ${() => `
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    text-align: center;

    `}
`;

export const StyledProfressonalAvatarContainer = styled.div`
    ${({ theme }) => `
    display: flex;
    align-items: flex-start;
    justify-content: center;
    flex-wrap: wrap;

    width: 70%;

    margin-top: 30px;
    row-gap: 20px;
    column-gap: 20px;

    ${theme.breakpoints.up('md')} {
        margin-top: 50px;
        row-gap: 30px;
    }
    ${theme.breakpoints.up('lg')} {
        margin-top: 70px;
        row-gap: 50px;
    }

    `}
`;

export const StyledAvatarContainer = styled.div`
    ${({ theme }) => `
    display: flex;
    flex-direction: column;
    align-items: center;

    flex-basis: 25%;

    & > img {
        max-width: 80px;
        ${theme.breakpoints.up('sm')} {
            max-width: 100px;
        }
        ${theme.breakpoints.up('md')} {
            max-width: 120px;
        }
        ${theme.breakpoints.up('lg')} {
            max-width: 135px;
        }
    }
    
    `}
`;

export const StyledWhySectionContainer = styled.div`
    ${({ theme }) => `
    background: linear-gradient(360deg, #E5F0FD -1.1%, #F1F6FD 29.35%, #F1F6FD 63.18%, #FFFFFF 100%);
    
    padding: 50px 20px;

    ${theme.breakpoints.up('sm')} {
        padding: 100px 50px;
    }
    ${theme.breakpoints.up('md')} {
        padding: 180px 70px 170px;
    }
    ${theme.breakpoints.up('lg')} {
        padding: 220px 175px 190px;
    }
    `}
`;

export const StyledWhyCardContainer = styled.div`
    ${({ theme }) => `
    display: grid;

    margin-top: 30px;
    column-gap: 15px;
    row-gap: 15px;

    grid-template-columns: 1fr;

    ${theme.breakpoints.up('sm')} {
        grid-template-columns: 1fr 1fr;
    }

    ${theme.breakpoints.up('md')} {
        margin-top: 50px;
        column-gap: 25px;
        row-gap: 20px;
    }
    ${theme.breakpoints.up('lg')} {
        margin-top: 75px;
        column-gap: 44px;
        row-gap: 32px;
    }
    `}
`;

export const StyledWhyCard = styled.div`
    ${({ theme }) => `
    background-color: #FFFFFF;
    border-radius: 20px;

    max-width: 550px;

    display: grid;
    grid-template-columns: auto 1fr;
    align-items: flex-start;
    
    padding: 15px 5px 20px;
    column-gap: 5px;

    ${theme.breakpoints.up('md')} {
        padding: 20px 20px 35px;
        column-gap: 15px;
    }
    ${theme.breakpoints.up('lg')} {
        padding: 25px 30px 30px;
        column-gap: 20px;
    }
    `}
`;

export const StyledIcon = styled.img`
    ${({ theme }) => `
    width: 50px;

    ${theme.breakpoints.up('sm')} {
        width: 60px;
    }
    ${theme.breakpoints.up('md')} {
        width: 80px;
    }
    ${theme.breakpoints.up('lg')} {
        width: 100px; 
    }
    `}
`;

export const StyledJoinSectionContainer = styled.div`
    ${({ theme }) => `
    background-color: #E7F1FE;

    display: grid;
    grid-template-columns: 1fr;

    padding: 0 10px 0;

    ${theme.breakpoints.up('sm')} {
        grid-template-columns: 1fr 1fr;
        padding: 0;
    }
    `}
`;

export const StyledJoinTextContainer = styled.div`
    ${({ theme }) => `
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    row-gap: 10px;

    ${theme.breakpoints.up('sm')} {
        align-items: flex-start;
        padding-left: 80px;
        row-gap: 15px;
    }
    ${theme.breakpoints.up('md')} {
        padding-left: 100px;
    }
    ${theme.breakpoints.up('lg')} {
        padding-left: 136px;
    }
    `}
`;

export const StyledTicketButton = styled(Button)`
    ${() => `
    background: linear-gradient(180deg, #FE5D83 0%, #E4567E 100%);

    backdrop-filter: blur(4px);
    border-radius: 16px;

    width: 96px;
    height: 48px;
`}
`;

export const StyledTicketCard = styled.div`
    ${({ theme }) => `
    background:
    linear-gradient(263.61deg, #FFFFFF 15.63%, rgba(255, 255, 255, 0.5) 94.52%);
    border: 1px solid #FFFFFF;
    border-radius: 16px;

    display: flex;
    align-items: center;
    column-gap: 20px;

    width: max-content;

    padding: 5px 5px 5px 15px;

    ${theme.breakpoints.up('sm')} {
        padding: 5px 5px 5px 25px;
    }
    `}
`;

export const StyledStartSectionTwo = styled.div`
    ${({ theme }) => `
    background-color: ${theme.palette.common.white};

    display: flex;
    align-items: center;
    justify-content: center;

    padding: 30px 0;

    ${theme.breakpoints.up('sm')} {
        padding: 80px 0;
    }
    ${theme.breakpoints.up('md')} {
        padding: 100px 0;
    }
    ${theme.breakpoints.up('lg')} {
        padding: 130px 0;
    }
    `}
`;
export const StyledMaskContainer = styled.div`
    ${({ theme }) => `

    background-image: url(${MaskBackground});
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center center;

    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    position: relative;
    border-radius: 24px;
    overflow: hidden;

    width: 90%;
    padding: 20px 0;

    ${theme.breakpoints.up('sm')} {
        row-gap: 10px;
        min-width: 700px;
        width: 80%;
        padding: 40px 0 50px;
    }
    ${theme.breakpoints.up('lg')} {
        padding: 50px 0 55px;
    }
    `}
`;

export const StyledFooterContainer = styled.div`
    ${({ theme }) => `
    background-color: ${theme.palette.common.white};

    padding-top: 20px;

    padding-bottom: 20px;

    ${theme.breakpoints.up('md')} {
        padding-bottom: 25px;
    }
    ${theme.breakpoints.up('lg')} {
        padding-bottom: 30px;
    }
    `}
`;
export const StyledButtonNavContainer = styled.div`
    ${({ theme }) => `
    margin: auto;

    display: grid;
    align-items: center;

    row-gap: 10px;
    grid-template-columns: 1fr;

    ${theme.breakpoints.up('sm')} {
        grid-template-columns: 1fr auto 1fr;
        width: 80%;
    }
    `}
`;
export const StyledButtonContainer = styled.div`
    ${() => `
    display: flex;
    align-items: center;

    `}
`;

export const StyledPlanSectionContainer = styled.div`
    ${({ theme }) => `
    display: flex;
    flex-direction: column;
    align-items: center;

    position: relative;

    margin-top: 30px;
    padding: 0 20px 100px;

    ${theme.breakpoints.up('sm')} {
        margin-top: 40px;
        padding: 0 20px 150px;
    }
    ${theme.breakpoints.up('lg')} {
        margin-top: 50px;
        padding: 0 20px 200px;
    }
    `}
`;

export const HalfBackground = styled.div`
    ${() => `
    background: linear-gradient(360deg, #E5F0FD 10%, #F1F6FD 56.3%, #FFFFFF 100%);

    position: absolute;

    left: 0;
    right: 0;
    bottom: 0;
    top:50%;
    `}
`;

export const StyledPlanCardContainer = styled.div`
    ${({ theme }) => `
    display: grid;

    z-index: 1;
    width: 100%;

    row-gap: 20px;
    grid-template-columns: 1fr;
    column-gap: 20px;

    ${theme.breakpoints.up('sm')} {
        grid-template-columns: 1fr 1fr;
        column-gap: 40px;
    }
    ${theme.breakpoints.up('lg')} {
        column-gap: 90px;
    }
    `}
`;

export const CardItemContainer = styled.div`
    ${({ theme }) => `
    flex-grow: 1;
    display: flex;
    flex-direction: column;
    justify-content: center;

    width: 100%;

    row-gap: 15px;

    ${theme.breakpoints.up('sm')} {
        row-gap: 20px;
    }
    `}
`;

export const StyledPlanButton = styled(Button)`
    ${({ theme }) => `
    background: linear-gradient(180deg, #FE5D83 0%, #E4567E 100%);
    backdrop-filter: blur(4px);

    border-radius: 34px;

    color: ${theme.palette.common.white};

    max-width: 293px;
    width: 80%;

    height: 42px;

    ${theme.breakpoints.up('md')} {
        height: 52px;
    }
    ${theme.breakpoints.up('lg')} {
        width: 293px;
        height: 62px;
    }
    `}
`;

export const StyledCardItem = styled.div`
    ${({ theme }) => `
    background: rgba(255, 255, 255, 0.2);
    backdrop-filter: blur(80px);

    border-radius: 20px;

    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;


    width: 100%;

    padding: 15px 0 10px;
    min-height: 130px;

    ${theme.breakpoints.up('sm')} {
        padding: 20px 0 15px;
        min-height: 157px;
    }
    `}
`;

export const StyledPlanCard = styled.div`
    ${({ theme }) => `
    background-color: ${theme.palette.common.black4};
    box-shadow: -3px 6px 78px -1px rgba(0, 0, 0, 0.04);
    border-radius: 24px;

    display: flex;
    flex-direction: column;
    align-items: center;

    &:nth-child(odd) {
        justify-self: end;
    }

    width: 100%;
    max-width: 458px;

    padding: 20px 25px 15px;
    row-gap: 15px;

    ${theme.breakpoints.up('sm')} {
        padding: 40px 30px 20px;
        row-gap: 20px;

    }
    ${theme.breakpoints.up('md')} {
        padding: 50px 40px 30px;
        row-gap: 25px;
    }
    ${theme.breakpoints.up('lg')} {
        padding: 60px 50px 40px;
        row-gap: 30px;
    }
    `}
`;

export const StyledBookSectionContainer = styled.div`
    ${({ theme }) => `
    display: flex;
    flex-direction: column;
    align-items: center;

    position: relative;

    padding: 0 10px 80px;

    ${theme.breakpoints.up('sm')} {
        padding: 0 20px 100px;
    }

    ${theme.breakpoints.up('md')} {
        margin-top: 40px;
        padding: 0 20px 150px;
    }
    ${theme.breakpoints.up('lg')} {
        margin-top: 50px;
        padding: 0 20px 200px;
    }
    `}
`;

export const StyledBookFormCard = styled.div`
    ${({ theme }) => `
    display: flex;
    flex-direction: column;

    background: #FFFFFF;
    border: 1px solid #F5F3F3;
    border-radius: 24px;
    z-index: 1;

    max-width: 672px;

    padding: 15px 20px;

    ${theme.breakpoints.up('sm')} {
        width: 50%;
        min-width: 500px;
        padding: 20px 30px;
    }
    ${theme.breakpoints.up('md')} {
        padding: 30px;
    }
    ${theme.breakpoints.up('lg')} {
        padding: 50px;
    }
    `}
`;

export const StyledInput = withStyles((theme) => ({
    root: {
        '& > .MuiInputBase-root': {
            background: 'rgba(221, 225, 240, 0.14) !important',

            width: '100%',

            borderRadius: '12px',

            paddingRight: '10px',

            border: `1px solid rgba(221, 225, 240, 0.14)`,

            '&:hover:not(.Mui-disabled)': {
                border: `1px solid #D5D8DC`,
            },

            '&.Mui-focused': {
                border: `1px solid #D5D8DC`,
            },

            '&.Mui-error': {
                border: `1px solid ${theme.palette.common.pink}`,

                '& input::placeholder': {
                    color: theme.palette.common.pink,
                },
            },

            '& input': {
                boxSizing: 'border-box',
                padding: '22px 0 22px 25px',

                height: '50px',
                [theme.breakpoints.up('sm')]: {
                    height: '58px',
                },

                '&::placeholder': {
                    color: '#D5D8DC',
                },
            },
        },
    },
}))(TextField);

export const StyledKeyboardDatePicker = withStyles((theme) => ({
    root: {
        '& > .MuiInputBase-root': {
            background: 'rgba(221, 225, 240, 0.14) !important',

            width: '100%',

            height: '50px',
            [theme.breakpoints.up('sm')]: {
                height: '58px',
            },

            borderRadius: '12px',

            border: `1px solid rgba(221, 225, 240, 0.14)`,

            '&:hover:not(.Mui-disabled)': {
                border: `1px solid #D5D8DC`,
            },

            '&:focus': {
                border: `1px solid #D5D8DC`,
            },

            '&.Mui-error': {
                border: `1px solid ${theme.palette.common.pink}`,

                '& input::placeholder': {
                    color: theme.palette.common.pink,
                },
            },

            '& input': {
                paddingLeft: '25px',

                '&::placeholder': {
                    color: '#D5D8DC',
                },
            },

            '& button': {
                padding: '10px',
                marginRight: '-10px',
            },

            '& fieldset': {
                border: 'none',
            },
        },
    },
}))(KeyboardDatePicker);

export const StyledBookSuccessContainer = styled.div`
    ${({ theme }) => `
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;

    max-width: 500px;

    ${theme.breakpoints.up('sm')} {
        min-width: 400px;
        width: 60%;
    }

    `}
`;
